import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import '../styles/HeroSection.css';

const HeroSection = () => {
  const [text, setText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [index, setIndex] = useState(0);
  const [delta, setDelta] = useState(100);
  
  const phrases = ['Études à l\'étranger', 'Immigration CANADA', 'Billetterie', 'Voyages organisés', 'Visa'];
  const typingRef = useRef(null);
  
  useEffect(() => {
    const handleTyping = () => {
      const currentPhrase = phrases[index];
      const shouldDelete = isDeleting;
      
      // Set text based on whether we're deleting or typing
      setText(prev => 
        shouldDelete 
          ? currentPhrase.substring(0, prev.length - 1) 
          : currentPhrase.substring(0, prev.length + 1)
      );
      
      // Set typing speed
      if (shouldDelete) {
        setDelta(50); // Faster when deleting
      } else {
        setDelta(100); // Normal speed when typing
      }
      
      // If completed typing the current phrase
      if (!shouldDelete && text === currentPhrase) {
        // Pause at the end of typing
        setDelta(2000);
        setIsDeleting(true);
      } 
      // If deleted the entire phrase
      else if (shouldDelete && text === '') {
        setIsDeleting(false);
        setIndex((prev) => (prev + 1) % phrases.length);
        setDelta(500); // Pause before typing the next phrase
      }
    };
    
    typingRef.current = setTimeout(handleTyping, delta);
    
    return () => {
      if (typingRef.current) {
        clearTimeout(typingRef.current);
      }
    };
  }, [text, index, isDeleting, delta, phrases]);
  
  return (
    <section id="home" className="hero-section">
      <div className="overlay"></div>
      <div className="container hero-container">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            Explorez le monde avec Saldae Voyage !
          </motion.h1>
          
          <motion.div 
            className="typing-text"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1, duration: 0.8 }}
          >
            <span>{text}</span>
            <span className="cursor">|</span>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.5, duration: 0.8 }}
          >
            <Link 
              to="contact" 
              smooth={true} 
              duration={800} 
              className="btn hero-btn"
            >
              Contactez-nous
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection; 